
export enum ExploreTileSizesEnum {
  sm = 'Small',
  md = 'Medium',
  lg = 'Large'
}